module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ../~/lodash/extend.js
// module id = 1756
// module chunks = 1